import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/store";
import LandingPage from "./Pages/landingPage/LandingPage";
import LogIn from "./Pages/auth/LogIn";
import Register from "./Pages/auth/Register";
import Role from "./Pages/onboarding/Role";
import UserForm from "./Pages/onboarding/UserForm";
import NgoForm from "./Pages/onboarding/NgoForm";
import ContactUs from "./Pages/onboarding/ContactUs";
import Toast from "./utils";
import "./index.css";
import NgoDocuments from "./Pages/onboarding/NgoDocuments";
import PrivateRoute, { getUserRoleAndStep } from "./Pages/auth/PrivateRoute";
import NotFound from "./Pages/error/NotFound";
import Unauthorized from "./Pages/error/Unauthorized";
import UserDocuments from "./Pages/onboarding/UserDocuments";
import Dashboard from "./Components/dashboard/Dashboard";
import EditCampaign from "./Components/dashboard/EditCampaign";
import Sidebar from "./Global/Sidebar";
// import Sidebar from "./Components/dashboard/Sidebar";
import Campaign from "./Components/dashboard/Campaign";
import CampaignDetail from "./Components/dashboard/CampaignDetail";
import CreateFundraiser from "./Components/dashboard/campaignDetail/fundraiser/CreateFundraiser";
import Settings from "./Components/dashboard/Settings";
import EditFundraiser from "./Components/dashboard/campaignDetail/fundraiser/EditFundraiser";
import Banner from "./Components/common/Banner";
import DonationPage from "./Components/donation/DonationPage";
import Header from "./Global/Header";
import WarningHeader from "./Components/dashboard/Warning";
import TermsAndConditions from "./Pages/termsAndConditions/TnC";
import Footer from "./Global/Footer";
import AddBankAccount from "./Pages/bankAccount/AddBankAccount";
import Layout from "./Global/Layout";
import HowItWorks from "./Pages/howItWorks/HowItWorks";
function App() {
  const [isGatewayAdded, setIsGatewayAdded] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // useEffect(() => {

  // Fetch the API response
  //   fetch(`${import.meta.env.VITE_API_URL_DASHBOARD_URL}/campaign`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setIsGatewayAdded(data.is_gateway_added);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching API:", error);
  //     });
  // }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState); // Toggle state between true and false
  };

  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Routes>
            <Route
              path="/dashboard/*"
              element={
                <>
                  {/* {!isGatewayAdded && <Banner />} */}

                  <Sidebar
                    isMenuOpen={isSidebarOpen}
                    toggleMenu={toggleSidebar}
                  />

                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route
                      path="/campaign"
                      element={
                        <PrivateRoute allowedRoles={["individual", "admin"]}>
                          <Campaign />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/campaign-detail/:id"
                      element={
                        <PrivateRoute allowedRoles={["individual", "admin"]}>
                          <CampaignDetail />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/campaigns/edit/:campaignId"
                      element={
                        <PrivateRoute allowedRoles={["individual", "admin"]}>
                          <EditCampaign />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/fundraisers/edit/:fundraiserId"
                      element={
                        <PrivateRoute allowedRoles={["individual", "admin"]}>
                          <EditFundraiser />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="fundraiser"
                      element={
                        <PrivateRoute allowedRoles={["individual", "admin"]}>
                          <CreateFundraiser />
                        </PrivateRoute>
                      }
                    />

                    <Route
                      path="settings"
                      element={
                        <PrivateRoute allowedRoles={["admin"]}>
                          <Settings />
                        </PrivateRoute>
                      }
                    ></Route>
                  </Routes>

                  <WarningHeader />
                </>
              }
            />

            {/* Updated Route for Donation Page with dynamic slug */}
            <Route
              path="/campaign/:slug"
              element={
                <>
                  <Header />
                  <DonationPage />
                  <Footer />
                </>
              }
            />
            <Route
              path="/settings/add-bank-account"
              element={
                <PrivateRoute allowedRoles={["admin"]}>
                  {/* <Header/> */}
                  <AddBankAccount />
                </PrivateRoute>
              }
            />

            <Route path="/" element={<LandingPage />} />

            <Route
              path="/login"
              element={
                <PrivateRoute allowedRoles={["free"]} path={"/login"}>
                  <LogIn />
                </PrivateRoute>
              }
            />

            <Route path="/register" element={<Register />} />

            <Route
              path="/onboarding/role"
              element={
                <PrivateRoute allowedRoles={["admin", "individual", "user"]}>
                  <Role />
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/userform"
              element={
                <PrivateRoute
                  allowedRoles={["individual", "user"]}
                  path={"/onboarding/userform"}
                >
                  <UserForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/ngoform"
              element={
                <PrivateRoute
                  allowedRoles={["admin", "user"]}
                  path={"/onboarding/ngoform"}
                >
                  <NgoForm />
                </PrivateRoute>
              }
            />
            <Route path="/contact" element={<ContactUs />} />
            <Route
              path="/onboarding/ngodocuments"
              element={
                <PrivateRoute
                  allowedRoles={["admin", "user"]}
                  path={"/onboarding/ngodocuments"}
                >
                  <NgoDocuments />
                </PrivateRoute>
              }
            />
            <Route
              path="/onboarding/userdocuments"
              element={
                <PrivateRoute allowedRoles={["user", "individual"]}>
                  <UserDocuments />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/donation" element={<DonationPage />} />

            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route
              path="/how-it-works"
              element={
                <Layout>
                  <HowItWorks />
                </Layout>
              }
            />
          </Routes>
        </div>
        <Toast />
      </Router>
    </Provider>
  );
}

export default App;
